module.exports = __webpack_public_path__ + "img/blue_phone_icon.e3b1d83.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/searchbox_imgs/blue_phone_icon.svg
// module id = ./assets/searchbox_imgs/blue_phone_icon.svg
// module chunks = 2 3 4 5 6 7